import { PromoCode } from '../../lib/types/models/promo-code/promo-code'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getPromoCode(id: number) {
  return restApiClient.url(constructApiUrl(API.promoCodes.get.url, { id })).get<PromoCode>()
}
